<template>
  <div id="knockaut-x-programmers-view">
    <v-card :color="isMainView ? '' : 'grey-lighten-4'">
      <template v-if="isMainView">
        <v-sheet color="primary">
          <v-card-title class="mx-0 py-3">Konfiguratoren</v-card-title>
        </v-sheet>
        <router-link
          v-for="item in menuItems"
          :key="item.location.name"
          :to="item.location"
          class="router-link"
        >
          <v-container class="d-flex ga-4">
            <figure class="mb-0">
              <v-icon
                :icon="item.icon"
                style="font-size: 46px"
                code="large"
                color="primary"
              />
            </figure>

            <p>
              <strong>{{ item.label }}</strong>
              <br />
              {{ item.description }}
            </p>
          </v-container>
        </router-link>
      </template>
      <v-sheet v-else color="primary">
        <v-card-text class="d-flex align-center">
          <v-btn
            size="small"
            icon="mdi-arrow-left-thick"
            color="white"
            @click="$router.back()"
          ></v-btn>
          <v-card-title>{{ viewTitle }}</v-card-title>
        </v-card-text>
      </v-sheet>
      <router-view></router-view>
    </v-card>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { brelagSupporterRouteName } from '@/apps/brelag/brelag-supporter/app'

const route = useRoute()
const isMainView = computed(() => {
  return route.name === brelagSupporterRouteName('knockautx-programmers')
})

const viewTitle = computed(() => {
  return menuItems.find((item) => item.location.name === route.name)?.label
})

const menuItems = [
  {
    label: 'Siegenia Konfigurator',
    description:
      'Konfiguriert die Lüftungsanlage einer Wohneinheit im Siegenia Projekt.',
    icon: 'mdi-alpha-s-box',
    location: { name: brelagSupporterRouteName('siegenia-programmer') },
  },
]
</script>

<style lang="scss" scoped>
.router-link {
  text-decoration: none;
  color: inherit;

  :hover p {
    text-decoration: underline;
  }
}
</style>
